export default __webpack_public_path__ + "static/clothing-v2-03-pants-inseam-f8ca01872eedc731e29dac56f366ebc1.png";